import React, { memo } from 'react';
import PropTypes from 'prop-types';

import classes from './DropdownMenuHeading.module.scss';

function DropdownMenuHeading({ className, fullName, city, state, country }) {
  const address = [city, state, country].filter(Boolean).join(', ');
  return (
    <div className={className}>
      <p className={classes.name}>{fullName}</p>
      {address && <p className={classes.location}>{address}</p>}
    </div>
  );
}

DropdownMenuHeading.propTypes = {
  className: PropTypes.string,
  fullName: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  country: PropTypes.string,
};

export default memo(DropdownMenuHeading);
